import { documentTitle, qs } from '@weapp/utils';
import uniq from 'lodash-es/uniq';
import { RouteComponentProps } from 'react-router-dom';
import { Comp } from '../components/page-view/types';

/*
 * 单级路由组件，可以动态挂在任何一级路由下
 * 需要获取父级路由
 */
export function fomatParentPath(props: RouteComponentProps) {
  return props.match.url.replace(/\/$/, () => '');
}

export function isBase64(str: string) {
  if (!str || str.trim() === '') {
    return false;
  }

  if (str.includes('?')) {
    [str] = str.split('?');
  }
  try {
    return btoa(atob(str)) === str;
  } catch (err) {
    return false;
  }
}

// 判断一个字符串是否是JSON类型
export const isJsonString = (str?: string) => {
  let result = true;
  if (str === undefined) {
    return false;
  }
  try {
    result = JSON.parse(str);
    result = true;
  } catch (error) {
    result = false;
  }
  return result;
};

// 是否为有效的组件
const isVaildCom = (com: Comp, coms: Comp[]) => {
  // 子组件关联了一个不存在的父组件
  if (com?.config?.flow?.parent) {
    return !!coms?.find((c: Comp) => {
      /**
       * 若筛选组件在非默认展示的选项卡标签内，
       * 页面加载时该筛选组件不会触发默认筛选，
       * requestQueue会导致关联组件一直处于加载中或筛选无效,
       * 此处进行处理避免
       */
      if (c?.id === com?.config?.flow?.parent) {
        if (c?.config?.flow?.parent && c?.type === 'InternalContainer') {
          const tabCom: any = coms?.find((tc: Comp) => tc?.id === c?.config?.flow?.parent);
          const linkedNodes: any = tabCom?.config?.flow?.linkedNodes;
          // 选项卡多个标签时需判断筛选组件是否存在于非默认标签
          if (tabCom?.config?.tabs?.length > 1 && linkedNodes) {
            // eslint-disable-next-line max-len
            const defaultActiveTab = tabCom?.config?.tabs?.find((t: any) => t?.defaultActive)?.id;
            if (linkedNodes?.[defaultActiveTab] === com?.config?.flow?.parent) {
              return true;
            }
            return false;
          }
        }
        return true;
      }
      return false;
    });
  }
  return true;
};

/**
 * 列表或图表预处理限制请求标识
 * @param comps 组件
 * @returns
 */
export function GetRequestQueue(comps: Comp[]) {
  const copyComps: any[] = comps;
  comps.forEach((c) => {
    if (
      c.type === 'FilterCondition'
      && !c.config.layout?.hidden
      && Array.isArray(c.config.filterCom?.val)
      && isVaildCom(c, comps)
    ) {
      copyComps.forEach((comp) => {
        if (c.config.filterCom.val.includes(comp.id) && c.config?.filterField?.length > 0) {
          if (comp.requestQueue) {
            comp.requestQueue.push(c.id);
            // 去重避免因为页面多次初始化从而引发赋值重复
            comp.requestQueue = uniq(comp.requestQueue);
          } else {
            comp.requestQueue = [c.id];
          }
        }
      });
    }
    if (c.type === 'SegControl' && !c.config.layout?.hidden && Array.isArray(c.config.segList)) {
      const seg = c.config.segList.find((el) => el.defaultActive);
      if (seg) {
        copyComps.forEach((comp) => {
          if (seg.eventRelatedComs?.includes(comp.id)) {
            if (comp.requestQueue) {
              comp.requestQueue.push(c.id);
              // 去重避免因为页面多次初始化从而引发赋值重复
              comp.requestQueue = uniq(comp.requestQueue);
            } else {
              comp.requestQueue = [c.id];
            }
          }
        });
      }
    }
  });
  return copyComps;
}

// 判断是否是登陆前页面 true 为登陆前页面
export function isPassportEbpage() {
  return window?.EBUILDER?.pageInfo?.module === 'LOGIN_PAGE' || window?.inPassportEbpage;
}

export const getPreviewStatusByUrl = () => {
  const { search } = window.location;
  const [, searchParams] = search?.split('?') || [];

  if (search && searchParams) {
    const { isPreviewPage } = qs.parse(searchParams);

    if (isPreviewPage === 'true') {
      return true;
    }
  }

  return false;
};

export const setDocumentTitle = (data: any) => {
  const { page } = data;
  if (page?.name) {
    documentTitle.setTitle({ title: page.name });
    // 单独设置titile 再来回点击时不生效
    document.title = page.name;
  }
};

// 定时器执行一次后销毁
export const setTimeoutOnce = (callback: Function, time: number = 0) => {
  const timer = setTimeout(() => {
    callback();

    if (timer) {
      clearTimeout(timer);
    }
  }, time);
};

export default {};
